import FormDetail from './formdetail.vue';
import OcmFormDetail from './ocmformdetail.vue';
import FormBox from './formbox.vue';
import FormCardBox from './formcardbox.vue';
import FormCardGroupBox from './formcardgroupbox.vue';
import DetailsBox from './detailsbox.vue';
import WorkForm from './workform.vue';
import BaseForm from './baseform.vue';
export {FormBox,FormDetail,OcmFormDetail,WorkForm,BaseForm,FormCardBox,FormCardGroupBox,DetailsBox};


// WEBPACK FOOTER //
// ./src/components/form/index.js